module.exports = __webpack_public_path__ + "img/fast1.5ed065a5.png";